"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    desc: "<p>\n    \u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u0430\u043A\u043A\u0443\u043C\u0443\u043B\u044F\u0442\u043E\u0440 - \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043E\u0434\u0430\u0440\u043E\u043A \u0434\u043B\u044F \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u0438 \u043F\u0430\u0440\u0442\u043D\u0451\u0440\u043E\u0432.\n  </p>",
};
